module.exports = {"370829001":"嘉祥镇街道","370829002":"卧龙山街道","370829003":"万张街道","370829101":"纸坊镇","370829102":"梁宝寺镇","370829104":"疃里镇","370829105":"马村镇","370829106":"金屯镇","370829107":"大张楼镇","370829108":"马集镇","370829110":"孟姑集镇","370829111":"老僧堂镇","370829112":"仲山镇","370829113":"满硐镇","370829114":"黄垓镇","370829400":"嘉祥经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370829.json
// module id = 1548
// module chunks = 0